var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40738 0.636353H26.5923V5.15046H7.40738V0.636353Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8494 5.15046V0.636353H33.3635V5.15046H28.8494Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40738 7.40751H26.5923V26.5925H7.40738V7.40751Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15032 26.5925V7.40751H0.63623V26.5925H5.15032Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.63623 28.8495V33.3636H5.15032V28.8495H0.63623Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40738 28.8495H26.5923V33.3636H7.40738V28.8495Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8494 28.8495V33.3636H33.3635V28.8495H28.8494Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3635 26.5925V7.40751H28.8494V26.5925H33.3635Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15032 0.636353H0.63623V5.15046H5.15032V0.636353Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLayer);
export default __webpack_public_path__ + "static/media/GridLayer.de954b85f52035fee18c237423294548.svg";
export { ForwardRef as ReactComponent };